import { render, staticRenderFns } from "./relitu.vue?vue&type=template&id=79a6fc3e&scoped=true&"
import script from "./relitu.vue?vue&type=script&lang=js&"
export * from "./relitu.vue?vue&type=script&lang=js&"
import style0 from "./relitu.vue?vue&type=style&index=0&id=79a6fc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a6fc3e",
  null
  
)

component.options.__file = "relitu.vue"
export default component.exports